import type { ChatMessageRow, JsonValue, VadiumMessage } from "@/lib/api";
import type { AssistantChatMessage } from "@/components/assistant/types";
import { getEvents } from "@/hooks/assistantChat/messageReducer";

export function assistantMessageToRow(msg: AssistantChatMessage): ChatMessageRow {
  if (msg.role === "user") {
    const hasFiles = msg.files && msg.files.length > 0;
    return {
      id: msg.id,
      role: "user",
      content: hasFiles ? ({ content: msg.content ?? "", files: msg.files } as unknown as JsonValue) : (msg.content ?? ""),
      created_at: msg.created_at
    };
  }
  return {
    id: msg.id,
    role: "assistant",
    content: (msg.events ?? []) as unknown as JsonValue,
    annotations: (msg.annotations ?? []) as unknown as JsonValue,
    status: msg.error ? "error" : undefined,
    created_at: msg.created_at
  };
}

/** Map completed messages to the wire history sent with a new turn. */
export function toHistory(messages: AssistantChatMessage[]): VadiumMessage[] {
  return messages
    .filter((message) => message.role === "user" || (message.role === "assistant" && !message.isStreaming))
    .map((message) => {
      const content = message.role === "user" ? (message.content ?? "") : getEvents(message).filter((event) => event.type === "content").map((event) => event.text).join("\n\n");
      if (message.role === "user") {
        return {
          role: message.role,
          content,
          files: message.files?.map((file) => ({ filename: file.filename, document_id: file.document_id }))
        };
      }
      return { role: message.role, content };
    });
}
